import _ from 'lodash';

import { requireFields } from 'bundles/naptimejs/util/requireFieldsDecorator';

import NaptimeResource from './NaptimeResource';

class onDemandCourseSchedules extends NaptimeResource {
  static RESOURCE_NAME = 'onDemandCourseSchedules.v1';

  @requireFields('defaultSchedule')
  get hasPeriods() {
    const { defaultSchedule } = this;
    return defaultSchedule && !_.isEmpty(defaultSchedule.periods);
  }
}

export default onDemandCourseSchedules;
